import { createSlice } from '@reduxjs/toolkit';
import { genericTableInitialState } from '../initialStates/genericTable';

const setPageAsClickedInArray = (state, action) => {
	if (!state.clickedPagesArray.includes(action.payload.pageNumber)) {
        state.clickedPagesArray.push(action.payload.pageNumber);
    }
};

const resetClickedPagesArray = (state, action) => {
    state.clickedPagesArray = [0];
};

const setTotalCount = (state, action) => {
    state.totalCount = action.payload.totalCount;
};

// const setSelectedRow = (state, action) => {
//     if (action.payload.selectedRow == state.selectedRow) {
//         state.selectedRow = null;
//         return;
//     }
//     state.selectedRow = action.payload.selectedRow;
// }

const genericTableSlice = createSlice({
  name: 'genericTable',
  initialState: genericTableInitialState,
  reducers: { 
    resetClickedPagesArray,
    setPageAsClickedInArray,
    setTotalCount,
    // setSelectedRow
  },
});

export const genericTableActions = genericTableSlice.actions;

export default genericTableSlice.reducer;
